import { z } from "zod";
import {
  TEXT_AGGREGATES,
  compareText,
  fail,
  ok,
  textOperators,
  type FieldKind,
} from "../kind";
import { scalarToText } from "./text";

export const emailSettings = z.object({});

// Volontairement simple : une adresse plausible, pas la RFC 5322 entière.
const EMAIL_RE = /^[^\s@<>()[\],;:"]+@[^\s@<>()[\],;:"]+\.[^\s@<>()[\],;:".]{2,}$/;

export const emailKind: FieldKind<"email"> = {
  type: "email",
  settings: emailSettings,
  value: z.string().regex(EMAIL_RE).max(320),
  coerce(input) {
    const raw = scalarToText(input);
    if (raw === null) return fail("Expected an email address.");
    // « Ada <ada@exemple.fr> », « mailto:ada@exemple.fr »
    const text = (/<([^>]+)>/.exec(raw)?.[1] ?? raw).trim().replace(/^mailto:/i, "");
    if (text === "") return ok(null);
    if (!EMAIL_RE.test(text) || text.length > 320) {
      return fail(`"${raw}" is not an email address.`);
    }
    // Le domaine est insensible à la casse, la partie locale en théorie non.
    const at = text.lastIndexOf("@");
    return ok(text.slice(0, at) + text.slice(at).toLowerCase());
  },
  format: (value) => value,
  compare: (a, b) => compareText(a, b),
  filters: textOperators<"email">((value) => value),
  aggregates: TEXT_AGGREGATES,
};
